import {BasicManagedFile} from './basicManagedFile'
import {SCH_SORT} from '../Data/typeDirs'

export default class SortingSchema extends BasicManagedFile {
  constructor(content){
    // console.log(content.length, typeof content[0], content[0].length)
    super(content)
    // console.log('constructing sortschema with name', name)
    this.ext = SortingSchema.getExt()
    this.typeDir = SortingSchema.getTypeDir()
  }

  static getExt(){
    return 'srt.json'
  }

  static getTypeDir(){
    return SCH_SORT
  }


  static async killLocalDBRecords(ds, name){
    return ds[SCH_SORT].kill({name})
  }
  serialize(){
    let superSerialized = super.serialize()
    const name = this.getName()
    superSerialized.name = name
    return superSerialized
  }

  getName(){
    let name = null
    // console.log('here I am', this)
    const ownTree = this.content.content[0].tree
    const ownName = ownTree.schemaName && ownTree.schemaName.content
    if( ownName && ownName.length === 1 ) {
      name = ownName[0]._name
    }
    return name
  }

  generateSuggestedName(){
    const obj = this.getSortObject()
    console.log('received sort object', obj)
    return obj.order.join(', ')
  }

  setName(name){
    this.content.content[0].tree.schemaName.content = this.content.content[0].tree.schemaName.content || []
    this.content.content[0].tree.schemaName.content[0] = this.content.content[0].tree.schemaName.content[0] || {}
    this.content.content[0].tree.schemaName.content[0]._name = name
  }

  getHidden(){
    const hiddenLeaf = this.content.content[0].tree.showHidden || {
      content: [{_name: 'Hide'}]
    }
    let hiddenValue = hiddenLeaf.content[0]._name
    return hiddenValue === 'Show'
  }

  getSortObject(){
    const jsonContent = this.content.content[0].tree.sortCreator.content
    // console.log('SORT OBJECT', this.content)
    let sortModalObj = null
    if(jsonContent && jsonContent.length === 1) {
      sortModalObj = JSON.parse(jsonContent[0]._name)
    }

    return sortModalObj
  }

  construct(data){
    // console.log('constructing from data', data)
    let result = super.construct(data)
    result.name = this.getName()
    // console.log('now I am', this)
    return result
  }
}
